import './all-res.css';

export function PermanceSubPage() {

    return (
        <div className="container-fluid m-4">
            <h4 className="gradient-text"> Performance </h4>
            <p className='para'>Make sure websites are optimized for fast loading times and efficient use of resources, which can impact the user experience and search engine optimization</p>
        </div>
    )
}